document.addEventListener("DOMContentLoaded", function () {
  // Target ONLY inside the cart
  document.querySelectorAll('.cart-item__details .product-option dt').forEach(function (dt) {
    // Remove leading number + dot + space (like "1. ", "2. ", "3. ", etc.)
    dt.textContent = dt.textContent.replace(/^\d+\.\s*/, '');
  });
});
